/* 
 * Project main javascript file. This file must be converter with
 * nodejs webpack. After processing the output file(s) will be stored
 * in following directory: Resources/Public/Javascript
 * 
 * This script implements following frameworks/components
 *  - jQuery 2.2.2
 *  - Foundation 6.2
 *  -- Tabs
 *  -- Orbit Slider
 *  -- Tooltips Slider
 *  - Flexslider
 *  - Revolution Slider
 *  - Lightcase
 *  - Mobile menu (mmenu)
 *  - Sticky Header
 *  - Link to top
 * 
 * @see https://webpack.github.io/docs/
 * @see https://nodejs.org/
 * 
 * Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Requires
var $ = window.$ = window.jQuery = require('jquery'); // force global scope
var somDefaultProjectConfig = require('./configs/default.config');
var somTranslator = require('./lang/translator');
var somProjectModules = [
	require('./components/foundation'),
	require('./components/scrolltop'),
	require('./components/mmenu'),
	require('./components/lightcase'),
	require('./components/focuspoint'),
	require('./components/solrautocomplete')
];

// Project construct
var $OM = function(){
				
	// Collection of private (__) and public methods
	var methods = {
		
		// Init var config
		config: {},	
		
		// Components variable - all initialized components
		// should be stored in this variable
		components: {},
		
		// Lang
		lang: null,
		
		/* 
		* Initialize the whole project
		* 
		* @return void
		*/
		__init: function() {
			
			// Set config
			this.config = somDefaultProjectConfig;
			if(typeof somProjectConfig === 'object'){
				$.extend(true, this.config, somProjectConfig);
			}

			// Init translator
			this.lang = somTranslator;
			this.lang.autoDetectLang();
			if(typeof this.config.langOverrides == 'object'){
				this.lang.extendLangData(this.config.langOverrides);
			}

			// Replace lang keys {LANG:key} in configuration (if enabled)
			if(this.config.project.configTranslationEnabled) {
				this.__translateConfiguration();
			}
						
			// Trigger event
			this.__triggerEvent('project', 'before');
					
			// Init components
			this.__initComponents(somProjectModules);
			
			// Trigger event
			this.__triggerEvent('project', 'after');
		},

		/*
		 * Translate configuration entries
		 *
		 * @return void
		 */
		__translateConfiguration: function() {

			this.config = this.__mapObjectPropertiesRecursive(this.config, function(property) {
				if(typeof property == 'string') {

					var regex = /{LANG:([^}]*)}/g;
					var matches;
					while (matches = regex.exec(property)) {
						property = property.replace(matches[0], this.lang.get(matches[1]));
					}

					return property;
				}
			}, ['project', 'components.foundation', 'langOverrides']);
		},

		/*
		 * Iterate through each object property recursive and
		 * call a user defined mapping function
		 *
		 * @param object object The object
		 * @param func callbackFunc User mapping function
		 * @return object The object
		 */
		__mapObjectPropertiesRecursive: function(object, callbackFunc, excludes, path, level) {

			// Init path / level variable if not defined
			if(typeof path == 'undefined') {
				path = [];
				level = 0;
			}

			// Loop through each property
			for (var property in object) {

				if (object.hasOwnProperty(property)) {

					// Create current path
					var currentPath = property;
					if(path.length > 0) {
						if(path.length - level) {
							path = path.slice(0, level - 1);
						}
						if(path.length > 0) {
							currentPath = path.join('.') + '.' + currentPath;
						}
					}

					// Process if it's not an exclude path
					if(excludes.indexOf(currentPath) == -1){

						// Recursive handle object
						if (typeof object[property] == 'object'){
							path.push(property);
							level++;
							object[property] = this.__mapObjectPropertiesRecursive(object[property], callbackFunc, excludes, path, level);

						// Mapping callback function for each other type
						} else {
							var returnVal = callbackFunc.apply(this, [object[property]]);
							if(typeof returnVal !== 'undefined') {
								object[property] = returnVal;
							}
						}
					}
				}
			}
			return object;
		},

		/* 
		* Initialize all components
		* 
		* @return void
		*/
		__initComponents: function(components) {
			
			var scope = this;
			$(components).each(function() {
				if(typeof this == 'object') {
					scope.__triggerEvent(this.name, 'before');
					if(this.init.apply(scope)) {
						scope.components[this.name] = this;
						scope.__triggerEvent(this.name, 'after');
					}
				}
			});
		},
		
		
		/* 
		* Get component config
		* 
		* @return void
		*/
		__getComponentConfig: function(componentPath) {
			
			var path = componentPath.split('.').reverse();
			var componentConfig = this.config.components;
			
			while(path.length > 0) {
				var currentPath = path.pop();
				if(typeof componentConfig[currentPath] == 'object') {
					componentConfig = componentConfig[currentPath];
					
					if(path.length == 0) {
						return componentConfig;
					}
				} else {
					path = [];
					return null;
				}
			}
		},
		
		/* 
		* Fire callback events
		* 
		* @return void
		*/
		__triggerEvent: function(module, event) {
			
			// Old way - trigger event by config
			var modulesPath = module.split('.').reverse();
			var componentConfig = this.config.components;
			if(modulesPath[0] == 'project') {
				componentConfig = {project: this.config.project};
			} 
			
			while(modulesPath.length > 0) {
				var currentPath = modulesPath.pop();
				if(typeof componentConfig[currentPath] == 'object') {
					componentConfig = componentConfig[currentPath];
					
					if(modulesPath.length == 0 
						&& typeof componentConfig['events'] == 'object' 
						&& typeof componentConfig['events'][event] == 'function') {
					
						componentConfig['events'][event](null, this);
					}
					
				} else {
					modulesPath = [];
				}
			}
			
			// Modern way - Trigger event by event listener
			$(document).trigger(module+':'+event, this);
		},
		
		/* 
		* Get Translation
		* 
		* @param string key 
		* @param object params 
		* @return string
		*/
		getTranslation: function(key, params) {
			this.lang.get(key, params);
		}
	};
	
	// Method calling logic
	if(arguments.length == 0) {
		return methods.__init.apply(methods, arguments);
	} else if(typeof arguments[0] === 'string' && arguments[0].substring(0,2) != '__' && methods[arguments[0]]) {
		return methods[ arguments[0] ].apply(this, Array.prototype.slice.call(arguments, 1));
	} else if(typeof arguments[0] === 'string') {
		console.log('Method ' + arguments[0] + ' does not exist for $OM');
	}
};

// Init project
$(document).ready(function(){$OM();});








/** WEBPACK FOOTER **
 ** ./src/project.js
 **/